import {Card, Typography} from '@mui/material';
import {ReactComponent as InfoIcon} from '../../../../../src/assests/svg/info_icon.svg';
import AurTooltip from '../../../common/aur-tooltip/AurTooltip';

interface CardItemProps {
  number: string;
  label: string;
  showInfo: boolean;
  tooltipTitle?: string; 
}

const CardItem: React.FC<CardItemProps> = ({number, label, showInfo, tooltipTitle}) => {
  return (
    <Card className="card-item">
      <div className="card-item-content">
        <Typography
          style={{color: '#F2F4F7'}}
          className="typo-text display1_size"
        >
          {number}
        </Typography>
        <Typography
          style={{color: '#A0AEC2'}}
          className="typo-text label1_size"
        >
          {label}
          {showInfo ? (
            <span className="tooltip-padding">
              <AurTooltip title={tooltipTitle}>
                <InfoIcon data-testid="info-icon"/>
              </AurTooltip>
            </span>
          ) : (
            ''
          )}
        </Typography>
      </div>
    </Card>
  );
};

export default CardItem;
